import React from "react"
import axios from "axios"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { Button, CustomInput, Spinner } from "reactstrap"
import { fail } from "../../actions"

// Admin controls for the customer's Azure billing policies:
// - viewCharges: can the customer's users see PAYG prices in the Azure portal
// - link to Partner Center for the reservation/savings plan purchase
//   permission (no public API for it)
class AzurePolicies extends React.Component {
  state = {
    fetching: true,
    updating: false,
    viewCharges: null,
  }

  componentDidMount = async () => {
    try {
      const { data } = await axios.get(
        `/customers/${this.props.customer.id}/azurepolicies`
      )
      this.setState({ fetching: false, viewCharges: data.viewCharges })
    } catch (error) {
      this.props.fail(null, error).then(() => this.setState({ fetching: false }))
    }
  }

  toggleViewCharges = async () => {
    const target =
      this.state.viewCharges === "Allowed" ? "NotAllowed" : "Allowed"
    this.setState({ updating: true })
    try {
      const { data } = await axios.patch(
        `/customers/${this.props.customer.id}/azurepolicies`,
        { viewCharges: target }
      )
      this.setState({ updating: false, viewCharges: data.viewCharges })
    } catch (error) {
      this.props.fail(null, error).then(() => this.setState({ updating: false }))
    }
  }

  render() {
    const { t, customer } = this.props
    return (
      <div className="my-3">
        <h3>{t("_azurePolicies")}</h3>
        {this.state.fetching ? (
          <Spinner size="sm" />
        ) : (
          <>
            <CustomInput
              type="switch"
              id="viewChargesSwitch"
              label={t("_azureViewCharges")}
              checked={this.state.viewCharges === "Allowed"}
              disabled={this.state.updating || this.state.viewCharges == null}
              onChange={this.toggleViewCharges}
            />
            {this.state.viewCharges == null && (
              <small className="text-muted">
                {t("_azurePolicyUnavailable")}
              </small>
            )}
          </>
        )}
        <div className="mt-2">
          <Button
            size="sm"
            color="secondary"
            tag="a"
            target="_blank"
            rel="noopener noreferrer"
            href={`https://partner.microsoft.com/dashboard/commerce2/customers/${customer.id}/account`}
          >
            {t("_reservationPermissionLink")}
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(null, { fail })(withTranslation()(AzurePolicies))
